var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":_vm.isDark ? 'dark':'light',"content":_vm.content,"placement":"top-start"}},[_c('span',[_vm._t("default"),_c('i',{staticClass:"el-icon-question",staticStyle:{"cursor":"pointer"}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }